import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _Qrcode from './qrcode.vue';

const Qrcode = Object.assign(_Qrcode, {
  install: (app: App, options?: ArcoOptions) => {
    // eslint-disable-next-line no-console
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _Qrcode.name, _Qrcode);
  },
});

export type ButtonInstance = InstanceType<typeof _Qrcode>;
export type { QrcodeProps } from './interface';

export default Qrcode;
